<template>
    <div class="h-12 w-full flex flex-row mt-2" :class="{'shadow-inner bg-blue-100': storeSelected == data.id}">
        <div class="h-full w-1/6 flex flex-col justify-center items-center">
            <div class="h-8 w-8 rounded-full flex flex-col justify-center items-center" :class="{'bg-green-300': data.goal_diff >= 0, 'bg-red-300': data.goal_diff < 0}">
                <span class="text-white text-xl">€</span>
            </div>
        </div>
        <div class="h-full w-5/6 border-b border-gray-300 flex items-center">
            <div class="h-1/3 w-full flex flex-row justify-between items-center pr-2">
                <span class="text-sm text-gray-800 font-semibold w-1/2">{{data.name}}</span>
                <span class="text-lg text-gray-600">{{data.current | reduceBigNumbers()}}€</span>
                <span class="text-lg text-gray-600 w-1/3 text-right" :class="{'text-green-400': data.goal_diff >= 0, 'text-red-400': data.goal_diff < 0}">{{data.goal_diff | reduceBigNumbers() }}€</span>
            </div>
        </div>
    </div>
</template>

<script>
import { state,actions } from '../store/store.js';

export default {
    props:['data'],
    computed:{
        storeSelected(){
            return state.store
        }
    }
}
</script>